module.exports = __webpack_public_path__ + "static/media/error_sds.8fd5ced9.svg";